import { cond, constant, stubTrue } from 'lodash-es';

export function getLeaseDealsValueRating(effectivePaymentRatio) {
  return cond([
    [() => effectivePaymentRatio >= 9, constant({ rating: 5, maxRating: 5 })],
    [() => effectivePaymentRatio >= 7.5, constant({ rating: 4, maxRating: 5 })],
    [() => effectivePaymentRatio >= 6.5, constant({ rating: 3, maxRating: 5 })],
    [() => effectivePaymentRatio >= 5.5, constant({ rating: 2, maxRating: 5 })],
    [stubTrue, constant({ rating: 1, maxRating: 5 })],
  ])();
}
